<template>
    <pre class="flow-debugging">{{ JSON.stringify(simplifiedCard, null, 2) }}</pre>
</template>

<script>
import { mapGetters } from '@generio-ai/library-legacy/plugins/vuex'

export default {
    name: 'FlowDebugging',
    props: {
        app: {
            type: String,
            required: true
        }
    },
    computed: {
        ...mapGetters('flows', [
            'getActiveCard'
        ]),
        card() {
            return this.getActiveCard(this.app)
        },
        simplifiedCard() {
            const copy = { ...this.card }
            copy.assets = copy.assets?.length
            copy.transaction = "[REDACTED]"
            return copy
        }
    }
}
</script>

<style scoped>
.flow-debugging {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: flex-start;
    padding-left: 10px;
    pointer-events: none;
    z-index: 10000;
    color: rgb(var(--v-theme-tertiary));
    white-space: pre-wrap;
    text-align: left;
    font-size: 1.2rem;
}
</style>
